import { useAppDispatch } from 'app/hooks';
import { useTranslation } from 'react-i18next';
import { DocumentActionComponent } from 'sanity';
import { useRevalidatePageByDomainMutation } from 'services/template-app';
import { setErrorMessage, setSuccessMessage } from 'store/toast-slice';

export const RevalidateContactPage: DocumentActionComponent = (props) => {
    const dispatch = useAppDispatch();
    useTranslation('sanity');
    const [revalidatePageByDomain, { isSuccess: revalidateSuccess, isError: revalidateError }] =
        useRevalidatePageByDomainMutation();
    return {
        label: 'Revalidate Contact Page',
        disabled: props.draft !== null,
        onHandle: async () => {
            if (props.published && props.published.domainName)
                await revalidatePageByDomain({
                    domainName: props.published.domainName as string,
                    paths: ['/contact', '/en/contact'],
                });

            // TODO: First time revalidation happens, message is not shown
            revalidateError && dispatch(setErrorMessage({ key: 'SANITY.CONTACT_PAGE_REVALIDATION_ERROR' })); // TODO: see how to implemnt this correctly
            revalidateSuccess && dispatch(setSuccessMessage({ key: 'SANITY.CONTACT_PAGE_REVALIDATION_SUCCESS' })); // TODO: see how to implemnt this correctly
        },
    };
};
